/* global google */

const mapElements = document.querySelectorAll('.mod-map__init');

function initialize(el, mapLat, mapLng, mapZoom, mapPin) {
  const mapOptions = {
    zoom: Number(mapZoom),
    center: new google.maps.LatLng(Number(mapLat), Number(mapLng)),
    streetViewControl: false,
    mapTypeControl: false,
    fullscreenControl: false,
    // disableDefaultUI: true,
    styles: [],
  };

  const map = new google.maps.Map(el, mapOptions);

  // eslint-disable-next-line no-unused-vars
  const marker = new google.maps.Marker({
    // eslint-disable-next-line object-shorthand
    map,
    position: new google.maps.LatLng(Number(mapLat), Number(mapLng)),
    icon: mapPin,
  });
}

Array.prototype.forEach.call(mapElements, (el) => {
  const mapLat = el.getAttribute('data-lat');
  const mapLng = el.getAttribute('data-lng');
  const mapZoom = el.getAttribute('data-zoom');
  const mapPin = el.getAttribute('data-pin');

  // eslint-disable-next-line no-unused-vars
  initialize(el, mapLat, mapLng, mapZoom, mapPin);
});
